import React, { SyntheticEvent, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import listFunction from '../admin/crudFunctions/listFunction'
import { client, visit } from '../interfaces'
import decode from 'jwt-decode'
import createFunction from '../admin/crudFunctions/createFunction'
import assets from '../admin/crudFunctions/assets'

interface reportForm {
  kind: number
  client_name: string
  client_phone?: string
  client_email?: string
  method: string
  amount: string
  client_address: string
  details: string
  creator: number
}

const NewReport = () => {
  const history = useHistory()
  const [kind, setKind] = useState<number>(0)
  const [kindList, setKindList] = useState<visit[] | null>(null)
  const [clientName, setClientName] = useState<string>('')
  const [clientPhone, setClientPhone] = useState<string>('')
  const [clientEmail, setClientEmail] = useState<string>('')
  const [clientAddress, setClientAddress] = useState<string>('')
  const [method, setMethod] = useState<string>('')
  const [amount, setAmount] = useState<string>('')
  const [details, setDetails] = useState<string>('')
  const [error, setError] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const visitEndpoint: string = 'visit/list'
  const url: string = assets.apiUrl + visitEndpoint

  const handleSubmit = async (e: SyntheticEvent) => {
    e.preventDefault()
    const refresh = localStorage.getItem('refresh')
    const { user_id }: { user_id: number } = decode(refresh!)
    const endpoint: string = 'report/create'
    const clientEndpoint: string = 'client/create'

    switch (kind) {
      case 0:
        setError('Debes elegir un tipo')
        break

      case 5:
        if (!clientName || !clientAddress || !details || !method || !amount) {
          setError('Debes llenar todos los campos')
        } else {
          const form: reportForm = {
            kind: kind,
            client_name: clientName,
            method: method,
            amount: amount,
            client_address: clientAddress,
            details: details,
            creator: user_id
          }
          const body: string = JSON.stringify(form)
          const response = await createFunction(endpoint, body)
          history.push({
            pathname: '/tecnico/reporte-final',
            state: { success: !!response }
          })
        }
        break

      default:
        if (
          !clientName ||
          !clientPhone ||
          !clientEmail ||
          !clientAddress ||
          !details ||
          !method ||
          !amount
        ) {
          setError('Debes llenar todos los campos')
        } else {
          const form: reportForm = {
            kind: kind,
            client_name: clientName,
            client_phone: clientPhone,
            method: method,
            amount: amount,
            client_email: clientEmail,
            client_address: clientAddress,
            details: details,
            creator: user_id
          }
          const client: client = {
            name: clientName,
            phone: clientPhone
          }
          const body: string = JSON.stringify(form)
          const clientBody: string = JSON.stringify(client)

          const response = await createFunction(clientEndpoint, clientBody)
          if (!response) {
            setError('Telefono ya en uso')
          } else {
            const success = await createFunction(endpoint, body)
            history.push({
              pathname: '/tecnico/reporte-final',
              state: { success: !!success }
            })
          }
        }
    }
  }
  useEffect(() => {
    listFunction(url).then((response) => {
      setKindList(response)
      setLoading(false)
    })
  }, [url])
  useEffect(() => {
    setClientName('')
    setClientPhone('')
    setClientEmail('')
    setClientAddress('')
    setDetails('')
    setError('')
  }, [kind])
  return (
    <div className='container grid justify-items-center md:mx-auto'>
      <div className='w-full bg-viper text-white text-4xl text-center h-20 flex items-center justify-center'>
        Nuevo Reporte
      </div>
      {loading ? (
        <div className='loader animate-spin mt-40'></div>
      ) : (
        <form className='grid mt-8' onSubmit={handleSubmit}>
          <label htmlFor='visit' className='text-2xl'>
            Tipo de visita
          </label>
          <select
            name='visit'
            id='visit'
            defaultValue={0}
            className='bg-white border-solid border-2 border-black rounded-full h-14 w-80 text-center text-2xl mb-8'
            onChange={(e) => setKind(parseInt(e.target.value))}>
            <option value={0} className='pl-4' disabled>
              Seleccione...
            </option>
            {kindList?.map((kind: visit) => {
              return (
                <option value={kind.id} key={kind.id}>
                  {kind.name}
                </option>
              )
            })}
          </select>
          <label htmlFor='clientName' className='text-2xl'>
            Nombre del cliente
          </label>
          <input
            type='text'
            name='clientName'
            value={clientName}
            id='clientName'
            className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-8'
            onChange={(e) => setClientName(e.target.value)}
          />
          {kind !== 5 && (
            <>
              <label htmlFor='clientPhone' className='text-2xl'>
                Teléfono
              </label>
              <input
                type='text'
                name='clientPhone'
                id='clientPhone'
                value={clientPhone}
                placeholder='04241234567'
                className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-8'
                onChange={(e) =>
                  setClientPhone(e.target.value.replace(/\D/, ''))
                }
              />

              <label htmlFor='clientEmail' className='text-2xl'>
                Correo
              </label>
              <input
                type='text'
                name='clientEmail'
                id='clientEmail'
                value={clientEmail}
                className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-8'
                onChange={(e) => setClientEmail(e.target.value)}
              />
            </>
          )}

          <label htmlFor='method' className='text-2xl'>
            Método de Pago
          </label>
          <input
            type='text'
            name='method'
            value={method}
            id='method'
            className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-8'
            onChange={(e) => setMethod(e.target.value)}
          />

          <label htmlFor='amount' className='text-2xl'>
            Monto Cobrado
          </label>
          <input
            type='text'
            name='amount'
            value={amount}
            id='amount'
            className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-8'
            onChange={(e) => setAmount(e.target.value)}
          />

          <label htmlFor='clientAddress' className='text-2xl'>
            Dirección
          </label>
          <textarea
            className='border-solid border-2 border-black rounded-lg text-lg text-center'
            name='clientAddress'
            id='clientAddress'
            onChange={(e) => setClientAddress(e.target.value)}
            value={clientAddress}
            cols={30}
            rows={5}></textarea>

          <label htmlFor='clientAddress' className='text-2xl mt-8'>
            Detalles
          </label>
          <textarea
            className='border-solid border-2 border-black rounded-lg text-lg text-center'
            name='details'
            id='details'
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            cols={30}
            rows={5}></textarea>

          {error && (
            <h2 className='text-red-500 text-xl text-center mt-5'>{error}</h2>
          )}

          <button
            type='submit'
            className='bg-viper active:bg-gray-800 rounded-full h-14 w-80 text-center text-white text-3xl mt-10 mb-32'>
            Enviar
          </button>

          <Link to='/tecnico/panel'>
            <button
              type='button'
              className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-3xl'>
              Atrás
            </button>
          </Link>
        </form>
      )}
    </div>
  )
}

export default NewReport
